var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('ShowcaseOperationsExecution',{attrs:{"showcase":_vm.showcase}}),_c('ShowcaseOperationsList',{attrs:{"showcase":_vm.showcase}}),_c('ScheduledOperationsList',{attrs:{"showcase":_vm.showcase}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }